import { Component, Input, Output, EventEmitter, ElementRef, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { ICondition, IConditionVariable } from '../../../../redux/timeline-data.model';
import { bbGenerateShortId } from '../../../../../../../shared/utils/bbGenerateShortId.util';
import { Subscription } from 'rxjs';

@Component({
	selector: 'condition',
	templateUrl: './condition.component.html',
	styleUrls: ['./condition.component.scss']
})

export class ConditionComponent implements OnInit, OnDestroy {

	@ViewChild('expressionInput') expressionInput: ElementRef;

	@Input() condition: ICondition;
	@Output() conditionChanged: EventEmitter<null>;
	@Output() removeRequest: EventEmitter<null> = new EventEmitter();
	@Output() expressionValueChange: EventEmitter<string> = new EventEmitter();
	@Input() expressionInvalid: boolean;

	optionList: any[] = [{
		label: 'Visibility',
		value: 'visibility',
		entityType: 'widget',
		components: [{
			iType: 'widgetSelector'
		},
		{
			iType: 'radioList',
			values: [
				{
					label: 'Visible',
					value: 'visible'
				},
				{
					label: 'Hidden',
					value: 'hidden'
				}
			]
		}],
		icon: 'eye'
	},
	{
		label: 'Player',
		value: 'player',
		entityType: 'player',
		components: [
			{
				iType: 'select',
				values: [
					{
						label: 'Is playing',
						value: 'isPlaying' // ?
					},
					{
						label: 'Hidden',
						value: 'hidden'
					}
				]
			}],
		icon: 'play-circle-o'
	},
	{
		label: 'Widget',
		value: 'widget',
		entityType: 'widget',
		icon: 'crosshairs'
	},
	{
		label: 'Local storage',
		value: 'localstorage',
		entityType: 'localstorage',
		icon: 'server'
	},
	{
		label: 'Comparison',
		value: 'comparison',
		entityType: 'compare',
		icon: 'adjust'
	}];
	abc = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
	buttonGroup: any[];
	startPosition: number;
	endPosition: number;

	public editable: boolean;
	private subscriptions: Subscription;
	// private lastMoveToIndex: number;
	private hasChanged = false;

	constructor() {
		this.conditionChanged = new EventEmitter<null>();
		this.subscriptions = new Subscription();
	}

	ngOnInit() {
		if (!this.condition) {
			this.condition = {
				variables: [],
				expression: ''
			};
		}

		if (!this.condition.id) {
			this.condition.id = bbGenerateShortId();
		}

		this.buttonGroup = [{
			label: '(',
			value: '('
		},
		{
			label: ')',
			value: ')'
		},
		{
			label: ' AND ',
			value: ' AND '
		},
		{
			label: ' OR ',
			value: ' OR '
		}];
	}

	ngOnDestroy() {
		if (this.subscriptions) {
			this.subscriptions.unsubscribe();
		}

		if (this.hasChanged) {
			this.dispatchChange();
		}
	}

	trackBy(i: number, conditionVariable: IConditionVariable) {
		return conditionVariable.name + i;
	}

	log(something: any) {
		// console.warn('Condition LOG: ', something);
	}

	dispatchChange(): void {
		this.conditionChanged.emit(null);
	}

	public editCondition() {
		this.editable = true;
		if (this.expressionInput) {
			this.expressionInput.nativeElement.value = this.condition.expression;
			this.expressionInput.nativeElement.focus();
		}

	}

	onKeyUp(event: KeyboardEvent): void {
		if (event.key === 'Enter' || event.key === 'Tab') {
			this.dispatchChange();
		}
	}

	expressionChange(value: string, moveToIndex?: number) {
		if (!this.expressionInput) {
			return;
		}

		this.hasChanged = true;

		// value = value.replace(/([ \(]) +/, '$1');
		// value = value.replace(/([^(?:and|or)]) +(\))/, '$1$2');

		// this.expressionInput.nativeElement.value = value;

		if (moveToIndex !== undefined && moveToIndex > -1) {
			this.expressionInput.nativeElement.focus();
			setTimeout(() => {
				this.expressionInput.nativeElement.selectionStart = this.expressionInput.nativeElement.selectionEnd = moveToIndex;
			});

			// this.lastMoveToIndex = moveToIndex;
		}
	}

	expressionChanged(value: string) {
		this.dispatchChange();
	}

	removeProcedure() {
		this.removeRequest.emit();
	}

	removeConditionVariable(conditionVariable: IConditionVariable): void {
		const index: number = this.condition.variables.indexOf(conditionVariable, 0);
		if (index > -1) {
			const ands = new RegExp('AND', 'g');
			const ors = new RegExp('OR', 'g');
			const removedRegex = new RegExp(conditionVariable.name, 'g');
			this.condition.expression = this.condition.expression.replace(ands, '&&&');
			this.condition.expression = this.condition.expression.replace(ors, '||');
			const replaceIndex = this.condition.expression.indexOf(conditionVariable.name);
			this.condition.expression = this.condition.expression.replace(removedRegex, '_');
			this.condition.variables.splice(index, 1);
			for (let i = index; i < this.condition.variables.length; i++) {
				const letterIndex = this.abc.indexOf(this.condition.variables[i].name);
				const newLetter = this.abc[letterIndex - 1];
				const regex = new RegExp(this.condition.variables[i].name, 'g');
				this.condition.expression = this.condition.expression.replace(regex, newLetter);
				this.condition.variables[i].name = newLetter;
			}
			this.condition.expression = this.condition.expression.replace(/\&\&\&/g, 'AND');
			this.condition.expression = this.condition.expression.replace(/\|\|/g, 'OR');
			if (!this.condition.variables.length) {
				this.condition.expression = '';
			}
			this.expressionChange(this.condition.expression, replaceIndex);
			this.dispatchChange();
		}
	}

	addConditionVariable(option: any): void {
		const letter = this.abc[this.condition.variables.length];
		this.condition.variables.push({
			name: letter,
			entityType: option.entityType,
			entityId: '',
			rule: {
				lvalue: option.value === 'visibility' ? 'visible' : '',
				operator: '==',
				rvalue: option.value === 'visibility' ? 'true' : ''
			}
		}
		);
		this.condition.expression += (this.condition.variables.length === 1 ? '' : ' AND ') + letter;

		this.expressionChange(this.condition.expression);
		this.dispatchChange();

	}

	addExpressionPart(operator: any) {
		this.startPosition = this.expressionInput.nativeElement.selectionStart;
		this.endPosition = this.expressionInput.nativeElement.selectionEnd;

		if (this.startPosition || this.startPosition === 0) {
			const startPos = this.startPosition;
			const endPos = this.endPosition;
			this.condition.expression = this.condition.expression.substring(0, startPos) +
				operator + this.condition.expression.substring(endPos, this.condition.expression.length);
			this.startPosition = startPos + operator.length;
			this.endPosition = startPos + operator.length;
		} else {
			this.condition.expression += operator;
		}

		this.expressionInput.nativeElement.focus();
		setTimeout(() => {
			this.expressionInput.nativeElement.selectionStart = this.expressionInput.nativeElement.selectionEnd = this.startPosition;
		});
	}

	conditionVariableChanged(): void {
		this.dispatchChange();
	}
}
